// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./../assets/fonts/Open_Sans/OpenSans-Bold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("./../assets/fonts/Open_Sans/OpenSans-SemiBold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("./../assets/fonts/Open_Sans/OpenSans-Medium.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("./../assets/fonts/Open_Sans/OpenSans-Regular.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Fonts */
@font-face {
  font-family: "Open Sans";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("truetype");
  font-weight: 700;
  font-style: normal;
  font-display: swap;
}

@font-face {
  font-family: "Open Sans";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___})
    format("truetype");
  font-weight: 600;
  font-style: normal;
  font-display: swap;
}

@font-face {
  font-family: "Open Sans";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format("truetype");
  font-weight: 500;
  font-style: normal;
  font-display: swap;
}

@font-face {
  font-family: "Open Sans";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_3___})
    format("truetype");
  font-weight: 400;
  font-style: normal;
  font-display: swap;
}

/* Global styles */
* {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}

:root {
  /* Background colors */
  --main-bg-color: #fbfbfb;
  --primary-bg-color: #0097a7;

  /* Text colors */
  --main-color: #332d2d;
  --primary-color: #ffffff;

  /* Container padding */
  --container-padding-sm: 1.5rem;
  --container-padding-md: 2rem;
  --container-padding-lg: 2.5rem;
  --container-padding-xl: 3rem;

  /* Section margin bottom */
  --section-spacing-sm: 2rem;
  --section-spacing-md: 3rem;
  --section-spacing-lg: 4rem;
  --section-spacing-xl: 5rem;
}

html {
  scroll-behavior: smooth;
}

body {
  font-family: "Open Sans", Arial, Verdana, Helvetica, sans-serif;
  background-color: var(--main-bg-color);
  color: var(--main-color);
  margin: 0;
  padding: 0;
}

ul {
  list-style: none;
  padding-left: 0;
}

/* Layout */
.container {
  max-width: 1200px;
  padding: var(--container-padding-sm);
  margin: 0 auto;
}

.about-me,
.my-work {
  margin-bottom: var(--section-spacing-sm);
}

.about-me .grid,
.my-work .grid,
.contact .grid {
  display: grid;
}

.my-work .grid,
.contact .grid {
  gap: 2rem;
}

.image-fluid {
  max-width: 100%;
  height: auto;
  display: block;
}

/* About Me section */
.about-background {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: auto;
  z-index: -1;
  transform: scale(-1, 1);
}

.about-me .grid {
  align-items: center;
}

.about-text {
  position: relative;
  z-index: 1;
}

.about-image {
  position: relative;
  text-align: center;
  margin-bottom: 1rem;
  z-index: 2;
}

.about-image img {
  position: relative;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.2);
  border-radius: 8px;
  z-index: 1;
}

.about-image .title {
  position: absolute;
  top: 100%;
  left: 50%;
  transform: translate(-50%, -100%);
  color: var(--primary-color);
  font-size: 3rem;
  font-weight: 700;
  text-align: center;
  width: 100%;
  z-index: 2;
}

.about-text .card {
  background-color: var(--primary-color);
  color: var(--main-color);
}

.about-text .card-title {
  font-size: 2.5rem;
  text-align: center;
  font-weight: 600;
  margin: 0 0 0.5rem;
}

.about-text .card-text {
  font-size: 1.25rem;
  line-height: 2rem;
  font-weight: 400;
  margin: 0 0 0.5rem;
}

.about-text .card-links {
  display: flex;
  justify-content: center;
  gap: 1rem;
  font-size: 2rem;
}

.about-text .card-link .card-icon {
  color: var(--main-color);
  transition: color 0.3s ease-in-out;
}

.about-text .card-link .card-icon:hover,
.about-text .card-link .card-icon:active {
  color: var(--primary-bg-color);
}

/* My Work section */
.my-work .title {
  margin-bottom: 1rem;
  font-size: 2rem;
  font-weight: 600;
}

.project-card {
  background-color: var(--primary-color);
  border-radius: 8px;
  box-shadow: 0px 4px 15px rgba(0, 0, 0, 0.1);
}

.project-card .image-fluid {
  border-radius: 8px 8px 0 0;
}

.project-card .card-header {
  padding: 1rem 2rem 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.project-card .card-body {
  padding: 1rem 2rem 2rem;
}

.project-card .card-title {
  font-size: 1.35rem;
  font-weight: 600;
}

.project-card .card-links {
  font-size: 1.35rem;
  display: flex;
  align-items: center;
  gap: 0.75rem;
  margin-left: 0.75rem;
}

.project-card .card-link {
  color: var(--main-color);
  transition: color 0.3s ease-in-out;
}

.project-card .card-link:hover,
.project-card .card-link:active {
  color: var(--primary-bg-color);
}

.project-card .card-text {
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.75rem;
}

/* Contact section */
.contact {
  background-color: var(--primary-bg-color);
  color: var(--primary-color);
}

.contact .grid {
  align-items: center;
}

.contact-text .title {
  font-size: 2.5rem;
  font-weight: 700;
  margin-bottom: 1rem;
}

.contact-text .text {
  font-size: 1.25rem;
  font-weight: 600;
}

.contact-text p.text {
  margin-bottom: 0.75rem;
}

.contact-text .address {
  margin-bottom: 1rem;
}

.contact-text p.contact-item {
  margin-bottom: 0.5rem;
}

.contact-text .contact-item a {
  text-decoration: none;
  color: var(--primary-color);
}

.contact-text .contact-item a:hover,
.contact-text .contact-item a:active {
  text-decoration: underline;
}

.contact-text .contact-item .contact-icon {
  margin-right: 0.75rem;
}

.contact-text .contact-links {
  font-size: 2.5rem;
  display: flex;
  justify-content: start;
  align-items: center;
  gap: 1.25rem;
}

.contact-text .card-link {
  color: var(--main-color);
  transition: color 0.3s ease-in-out;
}

.contact-text .card-link:hover,
.contact-text .card-link:active {
  color: var(--primary-color);
}

.contact-image img {
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.2);
  border-radius: 8px;
}

/* Medium devices */
@media (min-width: 768px) {
  .container {
    padding: var(--container-padding-md);
  }

  .about-me,
  .my-work {
    margin-bottom: var(--section-spacing-md);
  }

  .about-me .grid,
  .my-work .grid,
  .contact .grid {
    grid-template-columns: 1fr 1fr;
  }

  .about-me .grid {
    grid-template-columns: 3fr 4fr;
    align-items: baseline;
  }

  .about-image {
    margin-bottom: 0;
    transform: translate(20%);
  }

  .about-image .title {
    top: 0;
    left: 100%;
    transform: translate(-20%, 0%);
    text-wrap: nowrap;
  }

  .about-text .card {
    box-shadow: 0px 4px 15px rgba(0, 0, 0, 0.1);
    padding: 2rem;
    border-radius: 8px;
  }

  .about-text .card-links {
    justify-content: end;
  }
}

/* Large devices */
@media (min-width: 992px) {
  .container {
    padding: var(--container-padding-lg);
  }

  .about-me,
  .my-work {
    margin-bottom: var(--section-spacing-lg);
  }

  .about-me .grid {
    grid-template-columns: 1fr 1fr;
    align-items: center;
  }

  .about-image {
    transform: translateX(1rem);
  }

  .about-image .title {
    top: 100%;
    left: 50%;
    transform: translate(-50%, -100%);
    text-wrap: wrap;
  }

  .my-work .grid {
    grid-template-columns: repeat(3, 1fr);
    gap: 2.5rem 2rem;
  }

  .my-work .title {
    margin-bottom: 2rem;
  }
}

/* Extra large devices */
@media (min-width: 1200px) {
  .container {
    padding: var(--container-padding-xl);
  }

  .about-me,
  .my-work {
    margin-bottom: var(--section-spacing-xl);
  }

  .about-text .card-title,
  .about-text .card-text {
    margin-bottom: 1rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/css/styles.css"],"names":[],"mappings":"AAAA,UAAU;AACV;EACE,wBAAwB;EACxB,+DAA4E;EAC5E,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,wBAAwB;EACxB;sBACoB;EACpB,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,wBAAwB;EACxB,+DAA8E;EAC9E,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,wBAAwB;EACxB;sBACoB;EACpB,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA,kBAAkB;AAClB;EACE,sBAAsB;EACtB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,sBAAsB;EACtB,wBAAwB;EACxB,2BAA2B;;EAE3B,gBAAgB;EAChB,qBAAqB;EACrB,wBAAwB;;EAExB,sBAAsB;EACtB,8BAA8B;EAC9B,4BAA4B;EAC5B,8BAA8B;EAC9B,4BAA4B;;EAE5B,0BAA0B;EAC1B,0BAA0B;EAC1B,0BAA0B;EAC1B,0BAA0B;EAC1B,0BAA0B;AAC5B;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,+DAA+D;EAC/D,sCAAsC;EACtC,wBAAwB;EACxB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA,WAAW;AACX;EACE,iBAAiB;EACjB,oCAAoC;EACpC,cAAc;AAChB;;AAEA;;EAEE,wCAAwC;AAC1C;;AAEA;;;EAGE,aAAa;AACf;;AAEA;;EAEE,SAAS;AACX;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,cAAc;AAChB;;AAEA,qBAAqB;AACrB;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,WAAW;EACX,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,2CAA2C;EAC3C,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,SAAS;EACT,iCAAiC;EACjC,2BAA2B;EAC3B,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,WAAW;EACX,UAAU;AACZ;;AAEA;EACE,sCAAsC;EACtC,wBAAwB;AAC1B;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,wBAAwB;EACxB,kCAAkC;AACpC;;AAEA;;EAEE,8BAA8B;AAChC;;AAEA,oBAAoB;AACpB;EACE,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,sCAAsC;EACtC,kBAAkB;EAClB,2CAA2C;AAC7C;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,oBAAoB;EACpB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,oBAAoB;AACtB;;AAEA;EACE,wBAAwB;EACxB,kCAAkC;AACpC;;AAEA;;EAEE,8BAA8B;AAChC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA,oBAAoB;AACpB;EACE,yCAAyC;EACzC,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,2BAA2B;AAC7B;;AAEA;;EAEE,0BAA0B;AAC5B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,wBAAwB;EACxB,kCAAkC;AACpC;;AAEA;;EAEE,2BAA2B;AAC7B;;AAEA;EACE,2CAA2C;EAC3C,kBAAkB;AACpB;;AAEA,mBAAmB;AACnB;EACE;IACE,oCAAoC;EACtC;;EAEA;;IAEE,wCAAwC;EAC1C;;EAEA;;;IAGE,8BAA8B;EAChC;;EAEA;IACE,8BAA8B;IAC9B,qBAAqB;EACvB;;EAEA;IACE,gBAAgB;IAChB,yBAAyB;EAC3B;;EAEA;IACE,MAAM;IACN,UAAU;IACV,8BAA8B;IAC9B,iBAAiB;EACnB;;EAEA;IACE,2CAA2C;IAC3C,aAAa;IACb,kBAAkB;EACpB;;EAEA;IACE,oBAAoB;EACtB;AACF;;AAEA,kBAAkB;AAClB;EACE;IACE,oCAAoC;EACtC;;EAEA;;IAEE,wCAAwC;EAC1C;;EAEA;IACE,8BAA8B;IAC9B,mBAAmB;EACrB;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,SAAS;IACT,SAAS;IACT,iCAAiC;IACjC,eAAe;EACjB;;EAEA;IACE,qCAAqC;IACrC,gBAAgB;EAClB;;EAEA;IACE,mBAAmB;EACrB;AACF;;AAEA,wBAAwB;AACxB;EACE;IACE,oCAAoC;EACtC;;EAEA;;IAEE,wCAAwC;EAC1C;;EAEA;;IAEE,mBAAmB;EACrB;AACF","sourcesContent":["/* Fonts */\r\n@font-face {\r\n  font-family: \"Open Sans\";\r\n  src: url(\"./../assets/fonts/Open_Sans/OpenSans-Bold.ttf\") format(\"truetype\");\r\n  font-weight: 700;\r\n  font-style: normal;\r\n  font-display: swap;\r\n}\r\n\r\n@font-face {\r\n  font-family: \"Open Sans\";\r\n  src: url(\"./../assets/fonts/Open_Sans/OpenSans-SemiBold.ttf\")\r\n    format(\"truetype\");\r\n  font-weight: 600;\r\n  font-style: normal;\r\n  font-display: swap;\r\n}\r\n\r\n@font-face {\r\n  font-family: \"Open Sans\";\r\n  src: url(\"./../assets/fonts/Open_Sans/OpenSans-Medium.ttf\") format(\"truetype\");\r\n  font-weight: 500;\r\n  font-style: normal;\r\n  font-display: swap;\r\n}\r\n\r\n@font-face {\r\n  font-family: \"Open Sans\";\r\n  src: url(\"./../assets/fonts/Open_Sans/OpenSans-Regular.ttf\")\r\n    format(\"truetype\");\r\n  font-weight: 400;\r\n  font-style: normal;\r\n  font-display: swap;\r\n}\r\n\r\n/* Global styles */\r\n* {\r\n  box-sizing: border-box;\r\n  margin: 0;\r\n  padding: 0;\r\n}\r\n\r\n:root {\r\n  /* Background colors */\r\n  --main-bg-color: #fbfbfb;\r\n  --primary-bg-color: #0097a7;\r\n\r\n  /* Text colors */\r\n  --main-color: #332d2d;\r\n  --primary-color: #ffffff;\r\n\r\n  /* Container padding */\r\n  --container-padding-sm: 1.5rem;\r\n  --container-padding-md: 2rem;\r\n  --container-padding-lg: 2.5rem;\r\n  --container-padding-xl: 3rem;\r\n\r\n  /* Section margin bottom */\r\n  --section-spacing-sm: 2rem;\r\n  --section-spacing-md: 3rem;\r\n  --section-spacing-lg: 4rem;\r\n  --section-spacing-xl: 5rem;\r\n}\r\n\r\nhtml {\r\n  scroll-behavior: smooth;\r\n}\r\n\r\nbody {\r\n  font-family: \"Open Sans\", Arial, Verdana, Helvetica, sans-serif;\r\n  background-color: var(--main-bg-color);\r\n  color: var(--main-color);\r\n  margin: 0;\r\n  padding: 0;\r\n}\r\n\r\nul {\r\n  list-style: none;\r\n  padding-left: 0;\r\n}\r\n\r\n/* Layout */\r\n.container {\r\n  max-width: 1200px;\r\n  padding: var(--container-padding-sm);\r\n  margin: 0 auto;\r\n}\r\n\r\n.about-me,\r\n.my-work {\r\n  margin-bottom: var(--section-spacing-sm);\r\n}\r\n\r\n.about-me .grid,\r\n.my-work .grid,\r\n.contact .grid {\r\n  display: grid;\r\n}\r\n\r\n.my-work .grid,\r\n.contact .grid {\r\n  gap: 2rem;\r\n}\r\n\r\n.image-fluid {\r\n  max-width: 100%;\r\n  height: auto;\r\n  display: block;\r\n}\r\n\r\n/* About Me section */\r\n.about-background {\r\n  position: absolute;\r\n  top: 0;\r\n  left: 0;\r\n  width: 100%;\r\n  height: auto;\r\n  z-index: -1;\r\n  transform: scale(-1, 1);\r\n}\r\n\r\n.about-me .grid {\r\n  align-items: center;\r\n}\r\n\r\n.about-text {\r\n  position: relative;\r\n  z-index: 1;\r\n}\r\n\r\n.about-image {\r\n  position: relative;\r\n  text-align: center;\r\n  margin-bottom: 1rem;\r\n  z-index: 2;\r\n}\r\n\r\n.about-image img {\r\n  position: relative;\r\n  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.2);\r\n  border-radius: 8px;\r\n  z-index: 1;\r\n}\r\n\r\n.about-image .title {\r\n  position: absolute;\r\n  top: 100%;\r\n  left: 50%;\r\n  transform: translate(-50%, -100%);\r\n  color: var(--primary-color);\r\n  font-size: 3rem;\r\n  font-weight: 700;\r\n  text-align: center;\r\n  width: 100%;\r\n  z-index: 2;\r\n}\r\n\r\n.about-text .card {\r\n  background-color: var(--primary-color);\r\n  color: var(--main-color);\r\n}\r\n\r\n.about-text .card-title {\r\n  font-size: 2.5rem;\r\n  text-align: center;\r\n  font-weight: 600;\r\n  margin: 0 0 0.5rem;\r\n}\r\n\r\n.about-text .card-text {\r\n  font-size: 1.25rem;\r\n  line-height: 2rem;\r\n  font-weight: 400;\r\n  margin: 0 0 0.5rem;\r\n}\r\n\r\n.about-text .card-links {\r\n  display: flex;\r\n  justify-content: center;\r\n  gap: 1rem;\r\n  font-size: 2rem;\r\n}\r\n\r\n.about-text .card-link .card-icon {\r\n  color: var(--main-color);\r\n  transition: color 0.3s ease-in-out;\r\n}\r\n\r\n.about-text .card-link .card-icon:hover,\r\n.about-text .card-link .card-icon:active {\r\n  color: var(--primary-bg-color);\r\n}\r\n\r\n/* My Work section */\r\n.my-work .title {\r\n  margin-bottom: 1rem;\r\n  font-size: 2rem;\r\n  font-weight: 600;\r\n}\r\n\r\n.project-card {\r\n  background-color: var(--primary-color);\r\n  border-radius: 8px;\r\n  box-shadow: 0px 4px 15px rgba(0, 0, 0, 0.1);\r\n}\r\n\r\n.project-card .image-fluid {\r\n  border-radius: 8px 8px 0 0;\r\n}\r\n\r\n.project-card .card-header {\r\n  padding: 1rem 2rem 0;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n}\r\n\r\n.project-card .card-body {\r\n  padding: 1rem 2rem 2rem;\r\n}\r\n\r\n.project-card .card-title {\r\n  font-size: 1.35rem;\r\n  font-weight: 600;\r\n}\r\n\r\n.project-card .card-links {\r\n  font-size: 1.35rem;\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 0.75rem;\r\n  margin-left: 0.75rem;\r\n}\r\n\r\n.project-card .card-link {\r\n  color: var(--main-color);\r\n  transition: color 0.3s ease-in-out;\r\n}\r\n\r\n.project-card .card-link:hover,\r\n.project-card .card-link:active {\r\n  color: var(--primary-bg-color);\r\n}\r\n\r\n.project-card .card-text {\r\n  font-size: 1rem;\r\n  font-weight: 400;\r\n  line-height: 1.75rem;\r\n}\r\n\r\n/* Contact section */\r\n.contact {\r\n  background-color: var(--primary-bg-color);\r\n  color: var(--primary-color);\r\n}\r\n\r\n.contact .grid {\r\n  align-items: center;\r\n}\r\n\r\n.contact-text .title {\r\n  font-size: 2.5rem;\r\n  font-weight: 700;\r\n  margin-bottom: 1rem;\r\n}\r\n\r\n.contact-text .text {\r\n  font-size: 1.25rem;\r\n  font-weight: 600;\r\n}\r\n\r\n.contact-text p.text {\r\n  margin-bottom: 0.75rem;\r\n}\r\n\r\n.contact-text .address {\r\n  margin-bottom: 1rem;\r\n}\r\n\r\n.contact-text p.contact-item {\r\n  margin-bottom: 0.5rem;\r\n}\r\n\r\n.contact-text .contact-item a {\r\n  text-decoration: none;\r\n  color: var(--primary-color);\r\n}\r\n\r\n.contact-text .contact-item a:hover,\r\n.contact-text .contact-item a:active {\r\n  text-decoration: underline;\r\n}\r\n\r\n.contact-text .contact-item .contact-icon {\r\n  margin-right: 0.75rem;\r\n}\r\n\r\n.contact-text .contact-links {\r\n  font-size: 2.5rem;\r\n  display: flex;\r\n  justify-content: start;\r\n  align-items: center;\r\n  gap: 1.25rem;\r\n}\r\n\r\n.contact-text .card-link {\r\n  color: var(--main-color);\r\n  transition: color 0.3s ease-in-out;\r\n}\r\n\r\n.contact-text .card-link:hover,\r\n.contact-text .card-link:active {\r\n  color: var(--primary-color);\r\n}\r\n\r\n.contact-image img {\r\n  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.2);\r\n  border-radius: 8px;\r\n}\r\n\r\n/* Medium devices */\r\n@media (min-width: 768px) {\r\n  .container {\r\n    padding: var(--container-padding-md);\r\n  }\r\n\r\n  .about-me,\r\n  .my-work {\r\n    margin-bottom: var(--section-spacing-md);\r\n  }\r\n\r\n  .about-me .grid,\r\n  .my-work .grid,\r\n  .contact .grid {\r\n    grid-template-columns: 1fr 1fr;\r\n  }\r\n\r\n  .about-me .grid {\r\n    grid-template-columns: 3fr 4fr;\r\n    align-items: baseline;\r\n  }\r\n\r\n  .about-image {\r\n    margin-bottom: 0;\r\n    transform: translate(20%);\r\n  }\r\n\r\n  .about-image .title {\r\n    top: 0;\r\n    left: 100%;\r\n    transform: translate(-20%, 0%);\r\n    text-wrap: nowrap;\r\n  }\r\n\r\n  .about-text .card {\r\n    box-shadow: 0px 4px 15px rgba(0, 0, 0, 0.1);\r\n    padding: 2rem;\r\n    border-radius: 8px;\r\n  }\r\n\r\n  .about-text .card-links {\r\n    justify-content: end;\r\n  }\r\n}\r\n\r\n/* Large devices */\r\n@media (min-width: 992px) {\r\n  .container {\r\n    padding: var(--container-padding-lg);\r\n  }\r\n\r\n  .about-me,\r\n  .my-work {\r\n    margin-bottom: var(--section-spacing-lg);\r\n  }\r\n\r\n  .about-me .grid {\r\n    grid-template-columns: 1fr 1fr;\r\n    align-items: center;\r\n  }\r\n\r\n  .about-image {\r\n    transform: translateX(1rem);\r\n  }\r\n\r\n  .about-image .title {\r\n    top: 100%;\r\n    left: 50%;\r\n    transform: translate(-50%, -100%);\r\n    text-wrap: wrap;\r\n  }\r\n\r\n  .my-work .grid {\r\n    grid-template-columns: repeat(3, 1fr);\r\n    gap: 2.5rem 2rem;\r\n  }\r\n\r\n  .my-work .title {\r\n    margin-bottom: 2rem;\r\n  }\r\n}\r\n\r\n/* Extra large devices */\r\n@media (min-width: 1200px) {\r\n  .container {\r\n    padding: var(--container-padding-xl);\r\n  }\r\n\r\n  .about-me,\r\n  .my-work {\r\n    margin-bottom: var(--section-spacing-xl);\r\n  }\r\n\r\n  .about-text .card-title,\r\n  .about-text .card-text {\r\n    margin-bottom: 1rem;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
